import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let DeviceApp = class DeviceApp extends Vue {
};
DeviceApp = __decorate([
    Component({
        name: 'Home'
    })
], DeviceApp);
export default DeviceApp;
;
